<template>
  <EsimProfileGroup />
</template>

<script>
import EsimProfileGroup from './EsimProfileGroup/EsimProfileGroup.vue'
export default {
  components: {
    EsimProfileGroup
  }
}
</script>

<style scoped>

</style>
